import { Chip, styled } from "@mui/material";
import { Topic } from "api/types";
import clsx from "clsx";
import "./topic.scss";
import { topicsMap } from "./topics";

const StyledChip = styled(Chip)(({ theme }) => ({
	marginRight: theme.spacing(1),
	marginBottom: theme.spacing(1),
	padding: theme.spacing(1),
	backgroundColor: theme.palette.grey[200],
}));

export interface topicTagProps {
	selected?: boolean;
	name: Topic;
	onClick?: (name: Topic) => void;
	onDelete?: (name: Topic) => void;
}

export const TopicTag = ({
	selected,
	name,
	onClick,
	onDelete,
}: topicTagProps): JSX.Element => {
	const topic = topicsMap[name];

	// Conditionally defining the following handlers allows us to hide the `Chip` buttons in some cases
	const handleClick = onClick && (() => onClick?.(name));
	const handleDelete = onDelete && (() => onDelete?.(name));

	return (
		<StyledChip
			className={clsx(
				"tag",
				selected === false ? "unselected" : "selected",
				topic.className,
			)}
			key={name}
			label={name}
			icon={topic.icon}
			onClick={handleClick}
			onDelete={handleDelete}
		/>
	);
};
